"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asyncExpressCallHandler = void 0;
const tslib_1 = require("tslib");
const da_url_1 = require("@wix/da-url");
const exceptions_1 = require("./exceptions");
const errorCodes_1 = require("./errorCodes");
const log = require('@wix/wix-debug')('web');
exports.asyncExpressCallHandler = (asyncFn, onThrow) => {
    return (req, res, next) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        return asyncFn(req, res, next).catch(e => {
            // Instances of DaError mean we already caught that error and handled it, so skip them
            const skipError = Boolean(e.isDaError);
            if (skipError) {
                log.info('Skipping error', e);
                next(e);
                return;
            }
            if (e.response) {
                const { status, data } = e.response;
                // HTTP status 403 is from the loggedin filter
                if (status === 403 || status === 401) {
                    log.info('Redirecting to login', status);
                    res.redirect(302, da_url_1.Url.loginLink());
                    return;
                }
                // handle global error codes
                if (status === 400) {
                    const { errorCode, errorDetails } = data;
                    const errorKey = errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.errorKey;
                    const redirectUrl = errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.redirectUrl;
                    // handle redirects
                    if ([301, 302].includes(errorCode) && redirectUrl) {
                        // we rely on the backend returning a safe url here
                        log.info('Backend redirect received', 301);
                        res.redirect(errorCode, redirectUrl);
                        return;
                    }
                    const errorCodeException = errorCodes_1.handleErrorCodes(errorCode, errorKey);
                    if (errorCodeException) {
                        log.info('Error code', errorCodeException);
                        next(errorCodeException);
                        return;
                    }
                }
                // In theory, PAPI should not return 404s but if it happens we catch them here
                if (status === 404) {
                    log.info('Backend 404', status);
                    next(exceptions_1.NotFoundException('Resource not found', e));
                    return;
                }
            }
            // Each project may add its own error handling by passing an onThrow callback
            // Said callback can recover the error and bail out of this catch handler by
            // returning `false`.
            const exception = onThrow && onThrow(e, req, res);
            if (exception || exception === false) {
                exception && log.info('Project throwed', exception);
                next(exception || undefined);
                return;
            }
            // Default error handler
            log.info('Generic error', e);
            next(new exceptions_1.DaError(`Failed to render route ${req.url}`, e));
        });
    });
};
//# sourceMappingURL=asyncExpressCallHandler.js.map